import DokanOrderCard from '../card/DokanOrderCard';
import DokanSelectField from '../form/DokanSelectField';

function DownloadPermission() {
    return (
        <>
            <div>
                <DokanOrderCard hasTitle Title="Downloadable Product Permission" hasDivider>
                    <div className="px-30px grid grid-cols-1 justify-end items-center">
                        <div>
                            <DokanSelectField />
                        </div>
                        <div className="flex justify-between">
                            <div>&nbsp;</div>
                            <div className="mb-25px">
                                <button
                                    type="button"
                                    className="px-5 py-3 bg-green rounded-md text-white font-semibold"
                                >
                                    Grant Access
                                </button>
                            </div>
                        </div>
                    </div>
                </DokanOrderCard>
            </div>
        </>
    );
}

export default DownloadPermission;
